import React, { FunctionComponent, useState, useEffect, useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import {
  GridStyled,
  RowsSearchPanel,
  TablePanel,
  TableContainer,
  PaginationPanel,
  TableButton,
  InputSearch,
  TableCheck,
} from "./styled.components";
import { useSelector } from "react-redux";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

type GridModalProps = {
  columns: any;
  data: any;
  config?: any;
  pageStateIndex?: number;
  handleCheckedChange?: (e: any) => void;
  handlePageChange?: (e: any) => void;
};

const GridModal: FunctionComponent<GridModalProps> = ({
  columns,
  data,
  config,
  pageStateIndex = 0,
  handleCheckedChange,
  handlePageChange,
}) => {
  const [dataMap, setDataMap] = useState<any[]>([]);
  const { header } = useSelector((state: any) => state.theme);

  const [textfilter, settextfilter] = useState<string>("");
  useEffect(() => {
    setDataMap(formatedData());
  }, [data]);

  const handleRendeSelects = (select: any, item: any) => {
    let color = header?.gridHeader;
    return (
      <div className={"content-check"}>
        <TableCheck
          color={color}
          checked={item[select.valueSelect]}
          onChange={() => {
            handleCheckedChange && handleCheckedChange(item);
          }}
        />
      </div>
    );
  };

  const handleRenderOptions = (action: any, item: any) => {
    let color = action.color;
    let icon = action.icon;
    let hide = true;
    if (action.isStatus && action.isStatus !== "") {
      if (!item[action.isStatus]) {
        color = action.colorNegative;
        icon = action.iconNegative;
      }
    }
    if (action.accessorColumn && action.accessorColumn !== "") {
      if (item[action.accessorColumn]) {
        hide = false
      }
    }
    if (action.visible) {
      return (
        <div className={"content-button"}>
          <TableButton
            color={color}
            hidden={hide}
            visible={action.visible}
            onClick={() => {
              action.handle && action.handle(item);
            }}
          >
            {action.tooltip && action.tooltip != "" ? (
              <Tooltip title={action.tooltip} enterDelay={800} placement="top" style={{ fontFamily: "MontserratRegular" }}>
                <Icon style={{ fontSize: "clamp(0.7rem, 2.5vw, 1.2rem)", color: "#9C949480" }}>
                  {icon}
                </Icon>
              </Tooltip>
            ) : (
              <Icon style={{ fontSize: "clamp(0.7rem, 2.5vw, 1.2rem)" }}>
                {icon}
              </Icon>
            )}
          </TableButton>
        </div>
      );
    } else {
      return <></>;
    }
  };

  const formatedColumns = useMemo(() => {
    const selectsHeaders = config.selects
      .filter((select: any) => select.visible)
      .map((select: any) => {
        return {
          accessor: "chk" + select.action,
          Header: select.Header,
        };
      });
    const actionsHeaders = config.actions
      .filter((action: any) => action.visible)
      .map((action: any) => {
        return {
          accessor: "btn" + action.action,
          Header: action.Header,
        };
      });
    const newColumns = [...columns, ...selectsHeaders, ...actionsHeaders];
    return newColumns;
  }, []);

  const formatedData = () => {
    return data.map((item: any) => {
      config.selects.forEach((select: any) => {
        item["chk" + select.action] = handleRendeSelects(select, item);
        item.gridId = config.gridId;
      });
      config.actions.forEach((action: any) => {
        item["btn" + action.action] = handleRenderOptions(action, item);
      });
      return item;
    });
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setGlobalFilter,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns: formatedColumns,
      data: dataMap,
      initialState: { pageIndex: pageStateIndex },
    },
    useGlobalFilter,
    usePagination
  );

  const pageChange = (number: number) => {
    const pageChange = { gridId: config.gridId, page: number };
    handlePageChange && handlePageChange(pageChange);
    if (number > 0) {
      nextPage();
    } else {
      previousPage();
    }
  };

  return (
    <>
      <GridStyled>
        <RowsSearchPanel>
          <InputSearch
            type="text"
            value={textfilter || ""}
            placeholder={"Buscar"}
            onChange={(e: any) => {
              pageChange(-pageIndex)
              setGlobalFilter(e.target.value);
              settextfilter(e.target.value);
            }}
          />
        </RowsSearchPanel>
        <TablePanel>
          <TableContainer>
            <table {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup: any) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column: any) => (
                      <th
                        {...column.getHeaderProps()}
                        style={{
                          backgroundColor: header?.gridHeader,
                          color: header?.gridTextHeader,
                        }}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row: any) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell: any) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </TableContainer>
          <PaginationPanel>
            <div className={"pagination"}>
              <button
                onClick={() => pageChange(-1)}
                disabled={!canPreviousPage}
              >
                {"Anterior"}
              </button>{" "}
              <div className={"pagesCount"}>
                <span>
                  Página {pageIndex + 1} de {pageOptions.length}{" "}
                </span>
              </div>
              <button onClick={() => pageChange(1)} disabled={!canNextPage}>
                {"Siguiente"}
              </button>{" "}
            </div>
          </PaginationPanel>
        </TablePanel>
      </GridStyled>
    </>
  );
};

export default GridModal;
